export default "__VITE_ASSET__nArDSaUL__"